import { useAppDispatch } from '../../../../hooks/useAppDispatch'
import { blockArrayTypeCheck } from '../../../models/BlockArray/utils/blockArrayTypeCheck'
import React from 'react'
import { BlockArrayTypes } from '../../../models/BlockArray/types'
import { useInitialEffect } from '../../../../hooks/useInitialEffect'
import { modifyActionParameter } from '../../../../store/actions/actionsActions'
import { ArrayCardsACTN } from './ArrayCardsACTN/ArrayCardsACTN'
import { ChipListBlockACTN } from './ChipListACTN/ChipListBlockACTN'
import { PATH_JOINER } from '../../../models/utils/getConfigBitPath'

interface BlockArrayACTNProps {
    dataPath: string
    data: any[]
    schema: any
    title: string
    wrapper: string
    levelDeep?: number
    element_id?: string
}

export const BlockArrayACTN = (props: BlockArrayACTNProps) => {
    const {
        dataPath,
        data,
        schema = {},
        title,
        wrapper,
        levelDeep = 1,
        element_id,
    } = props

    const dispatch = useAppDispatch()
    const path = [...(dataPath.split(PATH_JOINER)), title]

    const schemaValues = Object.values(
        schema.children?.children || schema.children
    )
    const componentType = blockArrayTypeCheck(schemaValues, '')

    useInitialEffect(() => {
        if (data === null || data === undefined) {
            dispatch(
                modifyActionParameter({
                    path,
                    data: [],
                })
            )
        }
    })

    switch (componentType) {
        case BlockArrayTypes.TABLE:
            return <></>
        case BlockArrayTypes.CHIP_LIST:
            return (
                <ChipListBlockACTN
                    dataPath={dataPath}
                    data={data}
                    dataSchema={schema}
                    name={title}
                    wrapper={wrapper}
                    levelDeep={levelDeep}
                    element_id={element_id}
                />
            )
        default:
            return (
                <ArrayCardsACTN
                    dataPath={path}
                    schema={schema}
                    data={data || []}
                    title={title}
                    wrapper={wrapper}
                    element_id={element_id}
                />
            )
    }
}
